import React from 'react';

import {
  Actions as UIActions,
  Action,
  PlayArrowIcon,
  StopIcon,
  EditIcon,
  DeleteIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  ACTION_ARCHIVE,
  ACTION_DELETE,
  ACTION_EDIT,
  ACTION_RESTORE,
} from 'scenes/PartnerCompanies/constants';

export const Actions = ({
  actions,
  onEdit,
  onArchive,
  onRestore,
  onDelete,
  limit = 2,
}) => (
  <Permissions actions={actions}>
    {({ isActionAllowed }) => (
      <UIActions limit={limit}>
        {isActionAllowed(ACTION_RESTORE) && (
          <Action
            label={ACTION_RESTORE}
            icon={<PlayArrowIcon />}
            onClick={onRestore}
          />
        )}
        {(isActionAllowed(ACTION_ARCHIVE) ||
          !isActionAllowed(ACTION_RESTORE)) && (
          <Action
            label={ACTION_ARCHIVE}
            icon={<StopIcon />}
            onClick={onArchive}
            disabled={!isActionAllowed(ACTION_ARCHIVE)}
          />
        )}

        <Action
          label={ACTION_EDIT}
          disabled={!isActionAllowed(ACTION_EDIT)}
          onClick={onEdit}
          icon={<EditIcon />}
        />
        <Action
          label={ACTION_DELETE}
          disabled={!isActionAllowed(ACTION_DELETE)}
          onClick={onDelete}
          icon={<DeleteIcon />}
        />
      </UIActions>
    )}
  </Permissions>
);
